export enum CommonErrorCode {
	APPLICATION = 'APPLICATION',
}
